import { useMemo } from "react";
import { CustomElement } from "../../../../../slate";
import { createSelectSchema, FieldSchema, FieldType, Schema } from "../../../../hooks/useSchema";

export interface PreconfiguredField {
  code: string;
  label: string;
  type: string;
  options1?: string;
  options2?: string;
}

const doubleSplit = (text?: string) => text?.split("\n").map(x => x.trim()).filter(x => !!x).map(x => x.split(";").map(x => x.trim())) || [];

export const usePreconfiguredFields = (element: CustomElement) => {
  const x = useMemo(() => {
    const configsText = (element as any).preconfigured_fields || "";
    const fields: PreconfiguredField[] = doubleSplit(configsText)
      .map(([code, label, type, options1, options2]) => ({
        code: code.replace(/^-\s*/, ""),
        label,
        type,
        options1,
        options2,
      }));
    const schema = fields.reduce<Schema>((r,f) => {
      let fs: FieldSchema = { type: f.type as any, label: f.label };
      if(f.type === FieldType.select || f.type === FieldType.multiselect) {
        fs = createSelectSchema((f.options1 || "").split(",").map(s => s.trim()).map(s => ({ label: s, value: s })), { ...fs });
      }
      r[f.code] = fs;
      return r;
    }, {});

    return {
      fields,
      schema,
      fieldsCodes: new Set(fields.map(f => f.code)),
    }
    
  }, [element]);

  return x;
}
